require('./product-brands-edit-container.scss')

module.exports = {
  template: require('./product-brands-edit-container.pug')()
  controller: require('./product-brands-edit-container.ctrl')
}
